import type { DashboardScoreDiagnosticEntity } from '@/core/infrastructure/schemas/dashboard/DashboardScoreDiagnosticSchema'
import { DashboardScoreDiagnosticSchema } from '@/core/infrastructure/schemas/dashboard/DashboardScoreDiagnosticSchema'
import { DashboardScoreDiagnosticTask } from '@/core/domain/dashboard/DashboardScoreDiagnosticTask'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator'

export class DashboardScoreDiagnostic {
  readonly identifier: string
  readonly firstname: string
  readonly lastname: string
  readonly periodId: number
  readonly schoolYearName: string
  readonly classroomId: number
  readonly groupId: number | null
  readonly groupName: string | null
  readonly teacherId: number | null
  readonly teacherFirstname: string | null
  readonly teacherLastname: string | null
  readonly tasks: DashboardScoreDiagnosticTask[]

  constructor(scoreDiagnostic: DashboardScoreDiagnosticEntity) {
    this.identifier = scoreDiagnostic.identifier
    this.firstname = scoreDiagnostic.firstname
    this.lastname = scoreDiagnostic.lastname
    this.periodId = scoreDiagnostic.periodId
    this.schoolYearName = scoreDiagnostic.schoolYearName
    this.classroomId = scoreDiagnostic.classroomId
    this.groupId = scoreDiagnostic.groupId
    this.groupName = scoreDiagnostic.groupName
    this.teacherId = scoreDiagnostic.teacherId
    this.teacherFirstname = scoreDiagnostic.teacherFirstname
    this.teacherLastname = scoreDiagnostic.teacherLastname
    this.tasks = scoreDiagnostic.tasks.map((task) => DashboardScoreDiagnosticTask.create(task))
  }

  /**
   * Crée une instance de DashboardScoreDiagnostic à partir de données brutes
   */
  public static create(data: unknown): DashboardScoreDiagnostic {
    return EntityValidator.validateAndCreate(
      DashboardScoreDiagnosticSchema,
      data,
      DashboardScoreDiagnostic,
      'DashboardScoreDiagnostic'
    )
  }
}
